const initializeClubManagement = (root = document) => {
    /*
     * Plugin-Komponenten werden später hier initialisiert.
     *
     * Beispiel:
     * initializeSquadFilters(root);
     * initializeTrainingControls(root);
     */
};

export {
    initializeClubManagement,
};
